<template>
  <div class="quality">
    <div class="title">
      <div> {{ $t('main.aboutUs') }}</div>
    </div>
    <el-row>
      <div class="q-6-c">
        <div v-html=" $t('main.aboutUsContent') "></div>
        <div class="link" @click="goToAboutUs($t('main.aboutUs'))">
          {{ $t('main.viewMore') }} >
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  created() {},
  watch: {},
  methods:{
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      auxiliary(data);
      return res;
    },
    goToAboutUs(name) {
      let tab = JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo")));
      let item = this.treeToArray(tab).find(item => item.name == name);
      this.$router.push({
        path: this.getRoutesPath(item['list_template'], item['identification'], item['id'])
      });
    },
  }
};
</script>

<style lang="less" scoped>

.q-6-c {
  color: #333333;
  margin: 1rem 0 4.25rem 0;

  .link {
    margin: 10px;
    float: right;
    font-size: 1.1428rem;
    cursor: pointer;
    color: #635796;
  }
}

.quality {
  margin-top: 3.125rem;
  padding: 0 18%;
  .title {
    line-height: 4rem;
    font-size: 1.875rem;
    font-family: YouSheBiaoTiHei,serif !important;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }
}
</style>
